import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../axiosConfig';
import TasksTable from '../components/TasksTable';
import Table from '../components/Table';
import PageTitle from "../components/PageTitle";

const Dashboard = () => {
  
  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch {
      return null;
    }
  })();

  const defaultParticipants = [{
    id: user.user_contact_id,
    type: 'contact',
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
    is_sender: false,
  }];

  const [recentAccounts, setRecentAccounts] = useState([]);
  const [recentContacts, setRecentContacts] = useState([]);
  const [loadingRecent, setLoadingRecent] = useState(true);

  useEffect(() => {
    const fetchDashboard = async () => {
      setLoadingRecent(true);
      try {
        const res = await axios.get('/dashboard/', { withCredentials: true });
        setRecentAccounts(res.data?.recent_accounts || []);
        setRecentContacts(res.data?.recent_contacts || []);
      } catch (err) {
        console.error('Failed to fetch dashboard:', err);
        setRecentAccounts([]);
        setRecentContacts([]);
      } finally {
        setLoadingRecent(false);
      }
    };

    fetchDashboard();
  }, []);

  const accountColumns = useMemo(() => (
    [
      {
        key: 'name_short',
        header: 'Account',
        type: 'static',
        sortable: false,
        width: 112,
        render: (_value, row) => (
          <Link to={`/account?id=${row.id}`}>
            {row.name_short || row.name_long || `Account #${row.id}`}
          </Link>
        )
      },
      {
        key: 'name_long',
        header: 'Name',
        type: 'text',
        truncate: 120,
        width: 160
      }
    ]
  ), []);

  const contactColumns = useMemo(() => (
    [
      {
        key: 'last_name',
        header: 'Contact',
        type: 'static',
        sortable: false,
        width: 128,
        render: (_value, row) => (
          <Link to={`/contact?id=${row.id}`}>
            {`${row.first_name || ''} ${row.last_name || ''}`.trim() || `Contact #${row.id}`}
          </Link>
        )
      },
      {
        key: 'email',
        header: 'Email',
        type: 'text',
        truncate: 120,
        width: 144
      },
      {
        key: 'account_name_short',
        header: 'Account',
        type: 'static',
        sortable: false,
        width: 112,
        render: (_value, row) => {
          if (!row.account_id) return row.account_name_short || '—';
          return (
            <Link to={`/account?id=${row.account_id}`}>
              {row.account_name_short || `Account #${row.account_id}`}
            </Link>
          );
        }
      }
    ]
  ), []);

  return (
    <div className="page-layout">
      <PageTitle>Dashboard</PageTitle>
      
      <div className="page-content">
        <p>Welcome to your dashboard!</p>

        <TasksTable 
          contactId={user.user_contact_id} 
          defaultParticipants={defaultParticipants}
          onInteractionCreated={() => {}} 
        />

        <h3>Most Recent Accounts</h3>
        <Table
          data={recentAccounts}
          columns={accountColumns}
          loading={loadingRecent}
          emptyMessage="No recent accounts found."
        />

        <h3>Most Recent Contacts</h3>
        <Table
          data={recentContacts}
          columns={contactColumns}
          loading={loadingRecent}
          emptyMessage="No recent contacts found."
        />
      </div>
    </div>
  );
};

export default Dashboard;
